import { IDeleteGedDocumentoUseCase } from "../../../presentation/useCases/delete/delete_ged_documento_use_case";
import { TelasIds } from "../../../utils/tela_ids";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * DeleteGedDocumentoUseCase
 */

export class DeleteGedDocumentoUseCase implements IDeleteGedDocumentoUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async deleteGedDocumento(
    idTela: TelasIds,
    idGedDocumento: number,
  ): Promise<void> {
    await this.repository.deleteGedDocumento(idTela, idGedDocumento);
  }
}
